<template>
	<div class="baseBody relative">
    <div class="backBtn text-white" style="cursor: pointer;" @click="showFlage=!showFlage" >菜单</div>

    <div class="dateWeek">
			<DynamicDate></DynamicDate>
		</div>
		<div class="topHead flex justify-between">
			<div class="leftHead"></div>
			<div class="midHead">招商资源数据汇总</div>
			<div class="rightHead"></div>
		</div>
		<div id="main"></div>
		<div class="zwRightBox2"></div>
		<div  v-if="showFlage" class="zwRightBox">
			<div class="flex  align-center flex-wrap justify-center" style="height:100vh;box-sizing:border-box;padding:40% 0 40% 2%">
				<div >
					<div class="zwRightMneuItem" :class="index==1?'checked':''" v-for="(item,index) in rightMenuList" :key="index" style="margin:30px 0">
						<div class="text-center text-white text-bold base-font-24" @click="goBfzy(index)">{{item.name}}</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import DynamicDate from "../../components/dynamicDate/index.vue";
	import china from "echarts/map/json/china";
	// import router  from '../../router';
	import {
		getProjectNum
	} from "@/api/api"
	export default {
		components: {
			DynamicDate,
		},
		data() {
			return {
        showFlage:false,
				showSfZszyL: [],
				city:'',
				myChart:null,
				rightMenuList: [{
						id: 1,
						name: "拜访记录看板",
						left: 70
					},
					{
						id: 1,
						name: "招商资源看板",
						left: 30
					}
				],
				jsonList: [{
						name: "南海诸岛"
					},
					{
						ename: "beijing",
						name: "北京"
					},
					{
						ename: "tianjin",
						name: "天津"
					},
					{
						ename: "shanghai",
						name: "上海市"
					},
					{
						ename: "chongqing",
						name: "重庆"
					},
					{
						ename: "hebei",
						name: "河北"
					},
					{
						ename: "henan",
						name: "河南"
					},
					{
						ename: "yunnan",
						name: "云南"
					},
					{
						ename: "liaoning",
						name: "辽宁"
					},
					{
						ename: "heilongjiang",
						name: "黑龙江"
					},
					{
						ename: "hunan",
						name: "湖南"
					},
					{
						ename: "anhui",
						name: "安徽"
					},
					{
						ename: "shandong",
						name: "山东"
					},
					{
						ename: "xinjiang",
						name: "新疆"
					},
					{
						ename: "jiangsu",
						name: "江苏"
					},
					{
						ename: "zhejiang",
						name: "浙江"
					},
					{
						ename: "jiangxi",
						name: "江西"
					},
					{
						ename: "hubei",
						name: "湖北"
					},
					{
						ename: "guangxi",
						name: "广西"
					},
					{
						ename: "gansu",
						name: "甘肃"
					},
					{
						ename: "shanxi",
						name: "山西"
					},
					{
						ename: "neimenggu",
						name: "内蒙古"
					},
					{
						ename: "shanxi1",
						name: "陕西"
					},
					{
						ename: "jilin",
						name: "吉林"
					},
					{
						ename: "fujian",
						name: "福建"
					},
					{
						ename: "guizhou",
						name: "贵州"
					},
					{
						ename: "guangdong",
						name: "广东"
					},
					{
						ename: "qinghai",
						name: "青海"
					},
					{
						ename: "xizang",
						name: "西藏"
					},
					{
						ename: "sichuan",
						name: "四川"
					},
				 {
						ename: "ningxia",
						name: "宁夏"
					},
					{
						ename: "hainan",
						name: "海南"
					},
					{
						name: "台湾"
					},
					{
						ename: "xianggang",
						name: "香港"
					},
					{
						ename: "aomen",
						name: "澳门"
					},
				],
			}
		},
		mounted() {
			this.getProjectNum()
		},
		methods: {
			goBfzy(index){
				if(index==0){
					this.$router.push({path: '/'})
				}
				
			},
			initMap() {
				let _self=this
				_self.myChart = this.$echarts.init(document.getElementById("main"));
				// 注册的是中国地图，必须包括geo组件或者mep图标类型的时候才可以使用
				// 地图：世界地图，中国地图，省份地图，市区地图
				this.$echarts.registerMap("china", china);
				_self.myChart.clear()
				_self.myChart.setOption({
					geo: {
						map: "china",
						// 地图的长宽比例
						aspectScale: 0.75,
						// 图层
						zoom: 1.1,
						// 样式
						itemStyle: {
							normal: {
								borderColor: "#80c4dc",
								borderWidth: 5,
								areaColor: 'rgba(7,34,124,0.8)',
								fontWeightL: 700,
								shadowColor: 'rgba(19, 59,165, 1)',
								shadowOffsetX: -2,
								shadowOffsetY: 2,
								shadowBlur: 10
							},
							emphasis: {
								areaColor: '#389BB7',
								borderWidth: 0
							},
						},

						region: [{
							name: "南海诸岛",
							itemStyle: {
								opacity: 0,
							},
						}, ],
					},
					series: [
						// 配置地图相关的数据参数
						{
							type: "map",
							// symbol: 'pin', //气泡
							label: {
								normal: {
									// 显示文字
									show: true,
									textStyle: {
										color: "#1DE9B6",
									},

								},
								emphasis: {
									textStyle: {
										color: "rgb(183,185,14)",
									},
								},
							},
							data: _self.showData,

							// 图层
							zoom: 1.1,
							map: "china",
							itemStyle: {
								normal: {
									areaColor: {
										colorStops: [{
												offset: 0,
												color: "rgb(5,108,236)"
											},
											{
												offset: 1,
												color: "rgb(5,41,134)"
											},
										],
									},
									borderColor: '#fff',
									fontWeightL: 700,
									borderWidth: 1,
								},
								// 高亮效果
								emphasis: {
									areaColor: "rgb(46,229,206)",
									borderWidth: 0.1,
								},
							},
						},
						// 区域散点图
						{
							type: 'effectScatter',
							coordinateSystem: 'geo',
							zlevel: 2,
							symbolSize: 10,
							rippleEffect: { //坐标点动画
								period: 3,
								scale: 5,
								brushType: 'fill'
							},
							label: {
							  // normal: {
							  //   show: true,
							  //   position: 'right',
							  //   formatter: '{b}',
							  //   color: '#b3e2f2',
							  //   fontWeight: 'bold',
							  //   fontSize: 16
							  // }
							},
							data:_self.showSfZszyL,
							itemStyle: { //坐标点颜色
								normal: {
									show: true,
									color: '#ff8003',
									shadowBlur: 20,
									shadowColor: '#fff'
								},
								emphasis: {
									areaColor: '#f00'
								}
							}
						},
						{
							type: 'lines',
							zlevel: 3,
							symbol: 'circle',
							symbolSize: [5, 5],
							color: '#ff8003',
							opacity: 1,
							label: {
								show: true,
								padding: [10, 20],
								color: '#fff',
								backgroundColor: '#1a3961',
								borderColor: '#aee9fb',
								borderWidth: 1,
								borderRadius: 6,
								formatter(params) {
									// let arr = [params.name, '站点个数：' + params.value[1] + '家', '用户数' + params
									// 	.value[0] + '人'
									// ];
									
									let arr = [params.name+ '招商资源数：' + params.data.num];
									// return arr.join('\n');
									return arr
								},
								textStyle: {
									align: 'left',
									lineHeight:20,
									fontSize:16
								}
							},
							lineStyle: {
								type: 'solid',
								color: '#fff',
								width: 0.5,
								opacity: 1
							},
							data: _self.showSfZszyL
						}
					],
				},true);
				
				window.addEventListener('resize', function () {
				      _self.myChart.echarts.resize();
				     })
				_self.myChart.on("click", function(params) { //点击事件
				console.log(params,'params')
					_self.jsonList.forEach(item=>{
						if(item.name.indexOf(params.name)!==-1 || params.name.indexOf(item.name)!==-1){
							_self.city=item.ename
						}
						
					})
					if (params.componentSubType == "lines" || params.componentSubType=="map") {
					_self.$router.push({path: '/zszySf',query: {city:_self.city,name:params.name}});
			
					} else if (params.componentSubType == "effectScatter") {
						
						console.log('进入下个城市', params)
					}
					
				});
			},
			getProjectNum() {
				let _self=this
				getProjectNum(2).then(res => {
					var n=0
					res.data.forEach(function(item){
						n+=2.412
						_self.showSfZszyL.push({
								"name": item.name,
								"value": [item.longitude*1,item.latitude*1],
								"num":item.num,
								"coords": [
									[item.longitude*1,item.latitude*1],
									[item.longitude*1+1.3645,item.latitude*1+1.0645+n]
								]
						})
					})
					_self.initMap()
				})
			},
		}
	}
</script>

<style>
.backBtn{width:80px;height:40px;position:absolute;right:20px;top:5px;z-index:99999;line-height:40px;text-align:center;font-size:16px;border-radius: 7px;cursor:poiter;display: block;
  background: -webkit-linear-gradient(left, rgba(0,151,255,0.3) ,  rgba(0,151,255,0.5)); /* Safari 5.1 - 6.0 */
  background: -o-linear-gradient(right, rgba(0,151,255,0.3) ,  rgba(0,151,255,0.5)); /* Opera 11.1 - 12.0 */
  background: -moz-linear-gradient(right, rgba(0,151,255,0.3) ,  rgba(0,151,255,0.5)); /* Firefox 3.6 - 15 */
  background: linear-gradient(to right,rgba(0,151,255,0.3) ,  rgba(0,151,255,0.5));
}
.backBtn:hover{
  background: -webkit-linear-gradient(left, rgba(0,151,255,0.4) ,  rgba(0,151,255,0.7)); /* Safari 5.1 - 6.0 */
  background: -o-linear-gradient(right, rgba(0,151,255,0.4) ,  rgba(0,151,255,0.7)); /* Opera 11.1 - 12.0 */
  background: -moz-linear-gradient(right, rgba(0,151,255,0.4) ,  rgba(0,151,255,0.7)); /* Firefox 3.6 - 15 */
  background: linear-gradient(to right,rgba(0,151,255,0.4) ,  rgba(0,151,255,0.7)); /* 标准的语法*/
}
	.mapTcStyle {
		background: none !important;
		box-sizing: border-box;
		border-radius: 20px;
	}

	.tcNeiTitle {
		font-size: 22px;
		height: 50px;
		padding-top: 30px;
		font-weight: bold;
		color: #69f5ff;
	}

	.tcNeiBox .leftImage {
		width: 500px;
		height: 360px;
		padding: 10px;
		box-sizing: border-box;
		box-shadow: 0 0 20px inset #2281c4;
		;
	}

	.textInfo {
		height: 360px;
		width: 180px;
		font-size: 16px;
		color: #FFFFFF;
		line-height: 1.9;
		overflow-y: auto;
		padding-right: 10px;
		box-sizing: border-box;
	}

	#main {
		width: 100%;
		height: calc(100vh - 105px);
		position: relative;
	}

	#main::before {
		position: absolute;
		content: '';
		width: 100%;
		height: 100%;
		background: url('../../assets/images/allBg.png') 20px 150px no-repeat;
		background-size: 100% 100%;
		bottom: 0;
		left: 0;
		opacity: 0.5;
	}

	.leftMessageBox {
		position: absolute;
		left: 20px;
		z-index: 999;
		bottom: 50px;
		width: 360px;
		height: 185px;
		background: url('../../assets/images/leftBox.png') center no-repeat;
		background-size: 100% 100%;
		padding: 22px 31px;
	}

	.circle {
		width: 780px;
		height: 780px;
		position: absolute;
		left: -30%;
		top: calc(50% - 390px);
		opacity: 0.5;
		transform: scale(0.7);
		-o-transform: rotate(0.7);
		-webkit-transform: rotate(0.7);
		-moz-transform: rotate(0.7);

	}

	.circle1 {
		width: 780px;
		height: 780px;
		background: url('../../assets/images/circle1.png')center no-repeat;
		background-size: 100% 100%;
		position: absolute;
		animation: myfirst 15s infinite linear;
		-webkit-animation: myfirst 15s infinite linear;
		/* Safari and Chrome */
	}

	.circle2 {
		width: 780px;
		height: 780px;
		background: url('../../assets/images/circle2.png')center no-repeat;
		background-size: 100% 100%;
		left: 0;
		top: 0;
		position: absolute;
		animation: myfirst2 15s infinite linear;
		-webkit-animation: myfirst2 15s infinite linear;
		/* Safari and Chrome */
	}

	.circle3 {
		width: 780px;
		height: 780px;
		background: url('../../assets/images/circle3.png')center no-repeat;
		background-size: 100% 100%;
		left: 0;
		top: 0;
		position: absolute;
		animation: myfirst 15s infinite linear;
		-webkit-animation: myfirst 15s infinite linear;
		/* Safari and Chrome */
	}

	.circle4 {
		width: 780px;
		height: 780px;
		background: url('../../assets/images/circle4.png')center no-repeat;
		background-size: 100% 100%;
		left: 0;
		top: 0;
		position: absolute;
		animation: myfirst2 15s infinite linear;
		-webkit-animation: myfirst2 15s infinite linear;
		/* Safari and Chrome */
	}

	.dateWeek {
		position: absolute;
		top: 0;
		left: 0;
		width: 200px;
		height: 50px;
		color: #ffffff;
	}

	.leftMessageBox .neiBox {
		box-shadow: 0 0 50px inset rgba(0, 151, 255, 1);
		height: 140px;
		border-radius: 20px;
		padding: 17px;
		box-sizing: border-box;
	}

	.baseBody {
		width: 100%;
		height: 100vh;
		background: #000208 url('../../assets/images/bg1.png') center no-repeat;
		background-size: 100% 100%;
		overflow: hidden;
	}

	.zwRightBox {
		width: 2.8rem;
		height: calc(100vh - 0);
		position: fixed;
		top: 0;
		right: 0;
		bottom: 0;
		border-radius: 260px 0 0 160px/350px 0 0 300px;
		background: url('../../assets/images/leftBoxbg.png') center no-repeat;
		;
		background-size: 100% 100%;
		/* background: -webkit-linear-gradient(left, rgba(0,151,255,0.3) ,  rgba(0,151,255,0.03)); /* Safari 5.1 - 6.0 */
		/*  background: -o-linear-gradient(right, rgba(0,151,255,0.3) ,  rgba(0,151,255,0.03)); /* Opera 11.1 - 12.0 */
		/*  background: -moz-linear-gradient(right, rgba(0,151,255,0.3) ,  rgba(0,151,255,0.03)); /* Firefox 3.6 - 15 */
		/* background: linear-gradient(to right,rgba(0,151,255,0.3) ,  rgba(0,151,255,0.03)); /* 标准的语法 */
	}

	.zwRightBoxLine {
		width: 2px;
		height: 200px;
	}

	.zwRightMneuItem {
		background: url('../../assets/images/btnNormal.png') center no-repeat;
		background-size: 100% 100%;
    width: 2rem;
    height: 0.8rem;
    line-height: 0.8rem;
		cursor: pointer;
		transition: transform 0.5s;
		-webkit-transition: transform 0.5s;
		transform: scale(1);
		-webkit-transform: scale(1);
		/*兼容-webkit-引擎浏览器*/
		-moz-transform: scale(1);
	}

	.zwRightMneuItem:hover,.zwRightMneuItem.checked {
		background: url('../../assets/images/btnNormalChecked.png') center no-repeat;
		background-size: 100% 100%;
		cursor: pointer;
		transition: transform 0.5s;
		-webkit-transition: transform 0.5s;
		transform: scale(1.1);
		-webkit-transform: scale(1.1);
		/*兼容-webkit-引擎浏览器*/
		-moz-transform: scale(1.1);
	}

	.topHead {
		width: 100%;
		height: 103px;
	}

	.topHead .leftHead {
		width: 28%;
		height: 81px;
		background: url('../../assets/images/leftTop.png') center no-repeat;
		background-size: 100% 100%;
	}

	.topHead .midHead {
		width: 44%;
    height: 1.8rem;
		background: url('../../assets/images/midTop.png') center no-repeat;
		background-size: 100% 100%;
		text-align: center;
		font-weight: bold;
    font-size: 3em;
    line-height: 1.8rem;
		color: #FFFFFF;
	}

	.topHead .rightHead {
		width: 28%;
		height: 81px;
		background: url('../../assets/images/rightTop.png') center no-repeat;
		background-size: 100% 100%;
	}
</style>
